import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "../../data/mockData";
import { Menu, X } from "lucide-react";
import { DesktopNav } from "./DesktopNav";
import { MobileMenu } from "./MobileMenu";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(null);
  }, [location]);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-500">
      <nav
        className={`transition-all duration-500 ${
          scrolled
            ? "bg-white/95 backdrop-blur-md shadow-lg py-2"
            : "bg-white shadow-sm py-4"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="/logo.png"
              alt="Willow Ridge Golf & Country Club"
              className="w-12 h-12 object-contain group-hover:scale-105 transition-transform"
            />
            <div className="hidden sm:block">
              <div className="text-[#1B2A4A] font-serif text-xl font-bold leading-tight tracking-wide">
                Willow Ridge
              </div>
              <div className="text-[#C9A96E] text-xs font-medium tracking-[0.2em] uppercase">
                Golf & Country Club
              </div>
            </div>
          </Link>

          <DesktopNav
            navLinks={navLinks}
            isActive={isActive}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
          />

          {/* CTA + Mobile Toggle */}
          <div className="flex items-center gap-4">
            <Link
              to="/booking"
              className="hidden md:inline-flex items-center px-5 py-2.5 bg-[#1B2A4A] text-white text-sm font-medium rounded-md hover:bg-[#2a3d62] transition-colors duration-300"
            >
              Book Tee Time
            </Link>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden p-2 text-[#1B2A4A] hover:bg-gray-100 rounded-md transition-colors"
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        <MobileMenu
          navLinks={navLinks}
          isActive={isActive}
          mobileOpen={mobileOpen}
          mobileExpanded={mobileExpanded}
          setMobileExpanded={setMobileExpanded}
        />
      </nav>
    </header>
  );
};

export default Header;
